module.exports = __webpack_public_path__ + "static/img/144_TO8_1849.ab1a003.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/144_TO8_1849.jpg
// module id = y8Oe
// module chunks = 0